import { Attachment, Subscriber } from "models/dashboard/dashboard";

export type SelectedFilters = {
  flagged: boolean;
  unread: boolean;
  drafts: boolean;
  archived: boolean;
};

export enum InboxFiltersEnum {
  FLAGGED = "flagged",
  UNREAD = "unread",
  DRAFTS = "drafts",
  ARCHIVED = "archived"
}

export type MessageItem = {
  messageId: string;
  body: string;
  from: string;
  formatedFrom: string;
  createdAt: Date;
  attachments: Attachment[];
  type: string;
  subscribers?: Subscriber[];
  isRead?: boolean;
  isDeleted: boolean;
  isHidden?: boolean;
};

export type SentMessages = {
  messages: Omit<MessageItem, "subscribers">[];
  subscribers: Subscriber[];
};

export enum ThreadCategory {
  None = 0,
  Accounting = 1,
  Payroll = 2
}

export const THREAD_CATEGORY_LABELS: Record<ThreadCategory, string> = {
  [ThreadCategory.None]: "Ingen",
  [ThreadCategory.Accounting]: "Redovisning",
  [ThreadCategory.Payroll]: "Lön"
};

export type Thread = {
  limit: number;
  page: number;
  threadId: string;
  customerId: string;
  title: string;
  unread: boolean;
  gotAttachment: boolean;
  messageCount: number;
  lastMessage: MessageItem;
  messages: MessageItem[];
  subscriber?: Subscriber;
  subscribers: Subscriber[];
  isArchived: boolean;
  category?: ThreadCategory;
};

export type InboxType = "my" | "all" | "new" | "sent";

export enum TranslatedCategories {
  payroll = "Lön",
  accounting = "Redovisning",
  general = "Allmänt",
  reports = "Rapporter",
  uncategorised = "Okategoriserat"
}

export const inboxViews: { value: InboxType; label: string }[] = [
  { value: "my", label: "Mina konversationer" },
  { value: "all", label: "Alla konversationer" },
  { value: "sent", label: "Skickade meddelanden" }
];
